import DashboardPage from './page';
import { RouterConfig } from 'router/AppRoute';
import paths from 'helper/pathRoutes';

const routes: RouterConfig[] = [
  {
    path: paths.dashboard,
    page: DashboardPage,
  },
];

export default routes;
